import React from "react"
import { Modal } from "@mimber/ui-web"
import { DeleteEventForm } from "@/components/forms/DeleteEventForm"
import type { DeleteEventModalProps } from "./DeleteEventModal.types"

export const DeleteEventModal: React.FunctionComponent<
  DeleteEventModalProps
> = ({ event, onSuccess, ...modalProps }) => {
  return (
    <Modal title="Delete Event" footer={null} {...modalProps}>
      {(close) => (
        <DeleteEventForm
          event={event}
          onSuccess={() => {
            onSuccess?.()
            close()
          }}
          onCancel={close}
        />
      )}
    </Modal>
  )
}
